import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {Cta} from "../../blocks";
import ModalWindow from "../../components/modal-window";
import BodyControl from "../../components/body";
import Accordion from "../../components/accordion";
import Slider from "../../components/slider";
import {IS_MOBILE} from "../../constants/environment";
import {getComponents, getCookie, removeCookie, setCookie, isEqualId, formatId} from "../utilities";
import {convertPipeToBrTag} from "../../utils";

/**
 *  OwnerLibrary
 */
class OwnerLibrary extends Component {
  
  static iconCatalogWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAhFBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fWf706wAAAAK3RSTlMALSLWiO4XEQj48ubgy6+klY+BWEME+9HCm3xybGBNKAzcuKpqST85MCkcqGTk5QAAAMhJREFUOMvt08cOwjAMgOG06d57L/bw+78fAYOE1NKaI+O/RHK+Qw4x++iGiJsw3cjqHDAKDuANbAMEJ3ncbgqLWcImkl5gHhtkLLLKPRFjq0omYU9FX7TDMpaM2MvwOX6yiMWh1TnccpR+AeN1aKN3m3mMpd0Gv8kixvTGpWOh/viLsQoQpVTsi6FaJikJaw5cs8MDATM9VB87cnzCmqIobCKj8y30POoRzyZW1kSfB4jn09t1BvcYIW1bEDF2rl3ExOSKsx/rApVXQcsPEbyfAAAAAElFTkSuQmCC';
  static iconCatalogBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAeFBMVEUAAAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBALOulEAAAAJ3RSTlMALSIT+NaI7JQG8eXLr6SBa1hMQigZ/ODRwpuOfHJgDQncuKo+OSFdjNTAAAAAxUlEQVQ4y+3TRw7DIBBAURwbDO69t1Tuf8OYTBaRTMJkmfKX8ISQBshHN8fUkfo21qYSwmAu38C+lLzYbct0eF3LiSbrCabpgsUqrzshMbQfLigcuuDbaTZjS6QhzMWJciNWsxkbON5nhQHDdu+CDxITVonsCNcxYshOAjRW6o+/GLtSxgKLo3XR7XIcLmt48/yMwMTuPXmrZtYDLhljRJPIoruncQH4ZQt82bWGK2zKng4VeMBGn7QVYFzlGABGthso+bGuhwk7oDpyF+gAAAAASUVORK5CYII=';
  static iconPdfWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAWlBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fVogrzXAAAAHXRSTlMAf4dLlvvn3/HuYhLZ0nwi9XQ6Hg3FwKprWVNFM5Cqxq4AAAC4SURBVDjL5dTHDoNADEXRR5lCCYSSnvf/v5kBCSabwbBIkbhL6ywsWTJ2Exf6PJb7LiapTjVSkjoGYg4FsTKWZ4e1JiOHtTEmiA/oFIuUCRpqhxMAC7hX7AZckEVMm2V5ENtLyRID7mXsMs8R5/IaZV0DDmtDVvLOGDFpKrzhPz63hMMzTv0cY2wjjlZhb62MvW1FPNtjCxHP9iEfarIqgYS9vUPC3t4gYG+Zb3i5V6zHDdbjCrvrBVmbLH2hjickAAAAAElFTkSuQmCC';
  static iconPdfBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAXVBMVEUAAAAICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAhtHcNnAAAAHnRSTlMAf0qWh/vn3vEg7mIS2dL1fXQ1DQLFwKqKa1lTPgRZ37mdAAAAu0lEQVQ4y+XUyQ6DMAxF0QclCWFomTq37/8/swkSpBswLDpI3KV1FpYsGZuJM30ey30Xk1RHix1JfemQ0DeJlUl5clhrMnJYG2Mm8R5WsdgxRk3tcAxgBreK1uOCLBKmWZZP4vRcsoTHrYxdpulxLq9RWvuEw9qQlbwz4DFpou4N//G5BTwz49DPMfpW4mgRDjaVcbCNiEd7eEDEo43lQw1WxZBwsHdIONgbBBws8xUv94rluMZyXGFzvQDdBi4JXvW1vAAAAABJRU5ErkJggg==';
  static iconBlankWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAD19fWydBufAAAAAXRSTlMAQObYZgAAAClJREFUGNNjoBQw////B5NqYJBBp5ibKaSARmNQDUDjcVIw9/1HoygFAI58KxZwe2obAAAAAElFTkSuQmCC';
  static iconBlankBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAAICAhtdupNAAAAAXRSTlMAQObYZgAAAClJREFUGNNjoBQw////B5NqYJBBp5ibKaSARmNQDUDjcVIw9/1HoygFAI58KxZwe2obAAAAAElFTkSuQmCC';

  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    carSelectorLabel: PropTypes.string,
    generationSelectorLabel: PropTypes.string,
    libraryTitle: PropTypes.string,
    modelName: PropTypes.string,
    bodyType: PropTypes.shape({
      carId: PropTypes.string,
      generation: PropTypes.shape({
        carTypeCode: PropTypes.string,
        pastLibraryUrl: PropTypes.string,
        releaseDate: PropTypes.string,
        vehicleLibraryData: PropTypes.shape({
          vinData: PropTypes.string,
          information: PropTypes.string,
          freeArea: PropTypes.arrayOf(PropTypes.node),
          vehicleLibraryCategory: PropTypes.arrayOf(PropTypes.shape({
            manualCategory: PropTypes.string,
            vehicleLibraryItems: PropTypes.arrayOf(PropTypes.shape({
              linkFunction: PropTypes.string,
              linkItem1: PropTypes.string,
              linkTarget1: PropTypes.bool,
              linkIcon1: PropTypes.string,
              releaseDate: PropTypes.string,
              linkButtonTitle1: PropTypes.string,
              linkUpdatedate1: PropTypes.string,
              linkItem2: PropTypes.string,
              linkTarget2: PropTypes.bool,
              linkButtonTitle2: PropTypes.string,
              linkIcon2: PropTypes.string,
              linkUpdatedate2: PropTypes.string,
              titleAndPreText: PropTypes.string,
              agreementText: PropTypes.array,
              linkAreaTitle: PropTypes.string,
              lowerDescription: PropTypes.string,
            })),
          })),
        }),
      }),
    }),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    carSelectorLabel: null,
    generationSelectorLabel: null,
    libraryTitle: null,
    modelName: null,
    bodyType: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      currentStep: 0,
      currentVehicleType: 'Passenger Car',
      currentModelName: null,
      currentCarId: null,
      currentCarTypeCode: null,
      vehicleLibraryItem: null,
      isMounted: false,
    };
    this.refsAccordionArr = [];
    this.index = 0;
  }
  
  componentDidMount() {
    this.setState({
      isMounted: true,
    });
  
    // URLパラメータでダイレクト遷移
    this.setCurrentByParams();
  
  };
  
  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });
  }
  
  render() {
    
    // ナビゲーション表示
    const renderNavigation = ()=> {
      return (
        <div className="OwnerLibrary__navigation">
          <ol className="OwnerLibrary__navigation__list">
            {(() => {
              if (this.state.currentStep === 0) {
                return (
                  <li className="current">
                    <span>1</span>
                    {(this.props.carSelectorLabel && this.props.carSelectorLabel !== '') ? this.props.carSelectorLabel : '車種選択'}
                  </li>
                )
              } else {
                return (
                  <li>
                    <a className="OwnerLibrary__navigation__link"
                       href="javascript:void(0);"
                       onClick={(e)=> {
                         e.preventDefault();
                         // 車種選択に戻る
                         this.backToSelectBodyType();
                       }}
                    >
                      <span>1</span>
                      {(this.props.carSelectorLabel && this.props.carSelectorLabel !== '') ? this.props.carSelectorLabel : '車種選択'}
                    </a>
                  </li>
                )
              }
            })()}
            <li className={(this.state.currentStep === 1) ? 'current' : ''}>
              <span>2</span>
              {(this.props.generationSelectorLabel && this.props.generationSelectorLabel !== '') ? this.props.generationSelectorLabel : '発売年月選択'}
            </li>
          </ol>
          {(() => {
            if (1 <= this.state.currentStep) {
              return (
                <a className="OwnerLibrary__navigation__link-back"
                   href="javascript:void(0);"
                   onClick={(e)=> {
                     e.preventDefault();
                     // 車種選択に戻る
                     this.backToSelectBodyType();
                   }}>車種選択に戻る</a>
              )
            } else {
              return null;
            }
          })()}
        </div>
      )
    };

    // 車種選択表示
    const renderVehicleTypeSelect = ()=> {
      if (this.state.currentStep === 0) {
        
        const getVehicleTypeArr = ()=> {
          let arr = [];
          let i, max;
          for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
            let flg = true;
            let j, max2;
            for (j = 0, max2 = arr.length; j < max2; j = j + 1) {
              if (arr[j].vehicleType === this.props.models[i].vehicleType) {
                flg = false;
              }
            }
            if (flg) {
              arr.push({
                vehicleType: this.props.models[i].vehicleType,
                vehicleTabName: this.props.models[i].vehicleTabName,
              })
            }
          }
          return arr;
        };
        
        return (
          <div className="OwnerLibrary__vehicle-type-select">
            <ul className="OwnerLibrary__vehicle-type-select__list">
              {getVehicleTypeArr().map((vehicleType, index)=> {
                return (
                  <li key={index}>
                    <a className={'OwnerLibrary__vehicle-type-select__link' + ((this.state.currentVehicleType === vehicleType.vehicleType) ? ' current' : '')}
                       href="javascript:void(0);"
                       onClick={(e)=> {
                         e.preventDefault();
                         // 車種変更
                         this.changeVehicleType(vehicleType.vehicleType);
                       }}
                    >{vehicleType.vehicleTabName}</a>
                  </li>
                )
              })}
            </ul>
          </div>
        )
      } else {
        return null;
      }
    };
    
    // ボディタイプ選択表示
    const renderBodyTypeSelect = ()=> {
      if (this.state.currentStep === 0) {
  
        const getBodyTypeArr = ()=> {
      
          // いずれかの世代にPastLibraryURLかLibraryDataが存在しているか否か
          const isExistLibraryDate = (bodyType)=> {
            let i, max;
            for (i = 0, max = bodyType.generation.length; i < max; i = i + 1) {
              const generation = bodyType.generation[i];
              if (generation.pastLibraryUrl && generation.pastLibraryUrl !== '') {
                return true;
              } else if (generation.vehicleLibraryData) {
                return true;
              }
            }
            return false;
          };
      
          // 全てのGenerationにPastLibraryUrlが設定されていたら、直接リンクにする
          const getPastLibraryUrl = (bodyType)=> {
            let arr = [];
            let i, max;
            for (i = 0, max = bodyType.generation.length; i < max; i = i + 1) {
              const generation = bodyType.generation[i];
              if (generation.pastLibraryUrl && generation.pastLibraryUrl !== '') {
                arr.push({
                  releaseDate: generation.releaseDate,
                  pastLibraryUrl: generation.pastLibraryUrl,
                });
              } else {
                return null;
              }
            }
            // releaseDateでソート
            arr.sort((a, b)=> {
              if(a.releaseDate > b.releaseDate) return -1;
              if(a.releaseDate < b.releaseDate) return 1;
              return 0;
            });
            return arr[0].pastLibraryUrl;
          };
      
          let arr = [];
          let i, max;
          for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
            const model = this.props.models[i];
            if (this.state.currentVehicleType === model.vehicleType) {
              let j, max2;
              for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                const bodyType = model.bodyTypes[j];
            
                // すべての世代にPastLibraryURLもLibraryDataもなければ一覧に表示しない
                if (isExistLibraryDate(bodyType) === true) {
                  arr.push({
                    modelName: model.modelName,
                    vehicleType: model.vehicleType,
                    carId: bodyType.carId,
                    bodyTypeModel: bodyType.bodyTypeModelShort || bodyType.bodyTypeModelJa || bodyType.bodyTypeModel,
                    carTypeCode: (bodyType.defaultGeneration && bodyType.defaultGeneration !== '') ? bodyType.defaultGeneration : bodyType.defaultCarTypeCode || null,
                    pastLibraryUrl: getPastLibraryUrl(bodyType), // 全てのGenerationにPastLibraryUrlが設定されていたら、直接リンクにする
                  })
                }
            
              }
            }
          }
          return arr;
        };
    
        return (
          <div className="OwnerLibrary__body-type-select">
            <ul className="OwnerLibrary__body-type-select__list">
              {getBodyTypeArr().map((bodyType, index)=> {
                if (bodyType.pastLibraryUrl && bodyType.pastLibraryUrl !== '')  {
                  // すべてのGenerationにこれが設定されていたら直接リンクとする。
                  return (
                    <li key={index}>
                      <a className="OwnerLibrary__body-type-select__link" href={bodyType.pastLibraryUrl}>
                        <div className="OwnerLibrary__body-type-select__image-wrapper">
                          {(this.state.isMounted === true) ?
                            <img className="OwnerLibrary__body-type-select__image"
                                 src={this.getBodyTypeImageSrc(bodyType.vehicleType, bodyType.modelName, bodyType.carId, bodyType.carTypeCode)}/>
                            : null}
                        </div>
                        <div className="OwnerLibrary__body-type-select__text-wrapper"><span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(bodyType.bodyTypeModel)}}/></div>
                      </a>
                    </li>
                  )
                } else {
                  return (
                    <li key={index}>
                      <a className="OwnerLibrary__body-type-select__link"
                         href="javascript:void(0);"
                         onClick={(e)=> {
                           e.preventDefault();
                           // ボディタイプ変更
                           this.changeBodyType(bodyType.modelName, bodyType.carId);

                           // ブロックのCookieに保存
                           setCookie('mj_ombt', formatId(bodyType.carId));
                           removeCookie('mj_omgen');
  
                         }}
                      >
                        <div className="OwnerLibrary__body-type-select__image-wrapper">
                          {(this.state.isMounted === true) ?
                            <img className="OwnerLibrary__body-type-select__image"
                                 src={this.getBodyTypeImageSrc(bodyType.vehicleType, bodyType.modelName, bodyType.carId, bodyType.carTypeCode)}/>
                            : null}
                        </div>
                        <div className="OwnerLibrary__body-type-select__text-wrapper"><span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(bodyType.bodyTypeModel)}}/></div>
                      </a>
                    </li>
                  )
                }
              })}
            </ul>
          </div>
        )
      } else {
        return null;
      }
    };
    
    // 世代選択表示
    const renderGenerationSelect = ()=> {
      if (this.state.isMounted === true && this.state.currentStep === 1) {
        
        const getCurrentBodyTypeModel = ()=> {
          let i, max;
          for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
            const model = this.props.models[i];
            if (model.modelName === this.state.currentModelName) {
              let j, max2;
              for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                const bodyType = model.bodyTypes[j];
                // if (bodyType.carId === this.state.currentCarId) {
                if (isEqualId(bodyType.carId, this.state.currentCarId)) {
                  return bodyType.bodyTypeModelShort || bodyType.bodyTypeModelJa || bodyType.bodyTypeModel;
                }
              }
            }
          }
          return '';
        };
        
        const getGenerationArr = ()=> {
          let arr = [];
          let i, max;
          for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
            const model = this.props.models[i];
            if (model.modelName === this.state.currentModelName) {
              let j, max2;
              for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                const bodyType = model.bodyTypes[j];
                // if (bodyType.carId === this.state.currentCarId) {
                if (isEqualId(bodyType.carId, this.state.currentCarId)) {
                  let k, max3;
                  for (k = 0, max3 = bodyType.generation.length; k < max3; k = k + 1) {
                    const generation = bodyType.generation[k];
                    arr.push({
                      carTypeCode: generation.carTypeCode,
                      releaseDate: (generation.releaseDate) ? generation.releaseDate : null,
                      pastLibraryUrl: (generation.pastLibraryUrl) ? generation.pastLibraryUrl : null,
                    })
                  }
                }
              }
            }
          }
          // releaseDateでソート
          arr.sort((a, b)=> {
            if(a.releaseDate > b.releaseDate) return -1;
            if(a.releaseDate < b.releaseDate) return 1;
            return 0;
          });
          // 一番初めのPastLibraryURL以外をまとめる
          let arr2 = [];
          for (i = 0, max = arr.length; i < max; i = i + 1) {
            arr2.push(arr[i]);
            if (arr[i].pastLibraryUrl && arr[i].pastLibraryUrl !== '') {
              break;
            }
          }
          arr = arr2;
          //
          return arr;
        };
        
        // 世代アイテム表示
        const renderGenerationItem = (generation)=> {
          if (generation.pastLibraryUrl && generation.pastLibraryUrl !== '')  {
            return (
              <a className={'OwnerLibrary__generation-select__link-generation' + (isEqualId(this.state.currentCarTypeCode, generation.carTypeCode) ? ' current' : '')}
                 href={generation.pastLibraryUrl}
              >
                <span>{this.formatReleaseDate(generation.releaseDate)}以前</span>
                {(this.state.isMounted === true) ?
                  <img className="OwnerLibrary__generation-select__image-generation"
                       src={this.getBodyTypeImageSrc(this.state.currentVehicleType, this.state.currentModelName, this.state.currentCarId, generation.carTypeCode, 's', true, true)}/>
                  : null}
              </a>
            )
          } else {
            return (
              <a className={'OwnerLibrary__generation-select__link-generation' + (isEqualId(this.state.currentCarTypeCode, generation.carTypeCode) ? ' current' : '')}
                 href="javascript:void(0);"
                 onClick={(e)=> {
                   e.preventDefault();
                   // 世代選択
                   this.changeGeneration(generation.carTypeCode);
                   
                   // ブロックのCookieに保存
                   setCookie('mj_ombt', formatId(this.state.currentCarId));
                   setCookie('mj_omgen', formatId(generation.carTypeCode));
  
                 }}
              >
                <span>{this.formatReleaseDate(generation.releaseDate)}〜</span>
                {(this.state.isMounted === true) ?
                  <img className="OwnerLibrary__generation-select__image-generation"
                       src={this.getBodyTypeImageSrc(this.state.currentVehicleType, this.state.currentModelName, this.state.currentCarId, generation.carTypeCode, 's', true)}/>
                  : null}
              </a>
            )
          }
        };
        
        const generationArr = getGenerationArr();
        
        return (
          <div className="OwnerLibrary__generation-select">
            <h4 className="OwnerLibrary__generation-select__heading">{getCurrentBodyTypeModel()}</h4>
            {(() => {
              if (((IS_MOBILE === true) ? 3 : 7) <= generationArr.length) {
                return (
                  <Slider settings={{
                    autoplay: false,
                    autoplaySpeed: 3000,
                    speed: 1000,
                    ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                    fade: false,
                    infinite: true,
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    swipe: true,
                    draggable: false,
                    arrows: true,
                    dots: false,
                    adaptiveHeight: false,
                    centerMode: false,
                    centerPadding: 0,
                    //waitForAnimate: false,
                    lazyLoad: 'progressive',
                    responsive: [
                      {
                        breakpoint: 767,
                        settings: {
                          speed: 500,
                          slidesToShow: 2,
                          slidesToScroll: 2,
                          arrows: false,
                          dots: true,
                          centerMode: false,
                          //centerPadding: '10%',
                        },
                      },
                    ],
                  }}>
                    {generationArr.map((generation, index)=> {
                      return (
                        <div className="OwnerLibrary__generation-select__box" key={index}>
                          {renderGenerationItem(generation)}
                        </div>
                      )
                    })}
                  </Slider>
                )
              } else {
                return (
                  <ul className="OwnerLibrary__generation-select__list-generation" style={{width: (generationArr.length * 16.5) + '%'}}>
                    {generationArr.map((generation, index)=> {
                      return (
                        <li key={index}>
                          {renderGenerationItem(generation)}
                        </li>
                      )
                    })}
                  </ul>
                )
              }
            })()}
          </div>
        )
      } else {
        return null;
      }
    };
    
    // ライブラリデータ表示
    const renderLibraryData = ()=> {
      if (this.state.currentStep === 1) {
        
        const getCurrentGenerationInfo = ()=> {
          let i, max;
          for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
            const model = this.props.models[i];
            if (model.modelName === this.state.currentModelName) {
              let j, max2;
              for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                const bodyType = model.bodyTypes[j];
                // if (bodyType.carId === this.state.currentCarId) {
                if (isEqualId(bodyType.carId, this.state.currentCarId)) {
                  let k, max3;
                  for (k = 0, max3 = bodyType.generation.length; k < max3; k = k + 1) {
                    const generation = bodyType.generation[k];
                    // if (generation.carTypeCode === this.state.currentCarTypeCode) {
                    if (isEqualId(generation.carTypeCode, this.state.currentCarTypeCode)) {
                      return generation;
                    }
                  }
                }
              }
            }
          }
          return null;
        };
        
        const generationInfo = getCurrentGenerationInfo();
        const vinData = (generationInfo && generationInfo.vehicleLibraryData && generationInfo.vehicleLibraryData.vinData) ? generationInfo.vehicleLibraryData.vinData : null;
        const information = (generationInfo && generationInfo.vehicleLibraryData && generationInfo.vehicleLibraryData.information) ? generationInfo.vehicleLibraryData.information : null;
        const freeArea = (generationInfo && generationInfo.vehicleLibraryData && generationInfo.vehicleLibraryData.freeArea) ? generationInfo.vehicleLibraryData.freeArea : null;
        const releaseDate = (generationInfo && generationInfo.releaseDate) ? generationInfo.releaseDate : null;
        const libraryCategory = (generationInfo && generationInfo.vehicleLibraryData && generationInfo.vehicleLibraryData.vehicleLibraryCategory) ? generationInfo.vehicleLibraryData.vehicleLibraryCategory : null;
  
        // ライブラリカテゴリ表示
        const renderLibraryCategory = ()=> {
          if (libraryCategory && 1 <= libraryCategory.length) {
  
            // アコーディオン表示
            const renderAccordion = (category)=> {
              // 日付でソート
              category.vehicleLibraryItems.sort((a, b)=> {
                if(a.releaseDate > b.releaseDate) return -1;
                if(a.releaseDate < b.releaseDate) return 1;
                return 0;
              });
  
              this.index = this.index + 1;
              const ref = 'accordion' + this.index;
              this.refsAccordionArr.push(ref);

              return (
                <Accordion
                  pageName={category.manualCategory}
                  pcText={category.manualCategory}
                  mbText={category.manualCategory}
                  enabled={true}
                  ref={ref}
                >
                  <ul className="OwnerLibrary__library-data__list-ul">
                    {category.vehicleLibraryItems.map((vehicleLibraryItem, index)=> {
                      if (vehicleLibraryItem.linkFunction === 'Direct-Link') {
                        let iconClass = '';
                        if (vehicleLibraryItem.linkIcon1 === 'PDF') {
                          iconClass = ' pdf';
                        } else if (vehicleLibraryItem.linkIcon1 === 'E-Book') {
                          iconClass = ' e-book';
                        } else if (vehicleLibraryItem.linkIcon1 === 'Link') {
                          if (vehicleLibraryItem.linkTarget1 === true) {
                            iconClass = ' blank';
                          } else {
                            iconClass = ' link';
                          }
                        }
                        return (
                          <li key={index}>
                            <a className={'OwnerLibrary__library-data__link-modal2' + iconClass}
                               href={vehicleLibraryItem.linkItem1}
                               target={(vehicleLibraryItem.linkTarget1 === true) ? '_blank' : ''}
                            >{this.formatReleaseDate(vehicleLibraryItem.releaseDate)}〜</a>
                          </li>
                        )
                      } else {
                        return (
                          <li key={index}>
                            <a className="OwnerLibrary__library-data__link-modal2"
                              href="javascript:void(0);"
                              onClick={(e)=> {
                                e.preventDefault();
                                // モーダル開く
                                this.openModal(vehicleLibraryItem);
                              }}
                            >{this.formatReleaseDate(vehicleLibraryItem.releaseDate)}〜</a>
                          </li>
                        )
                      }
                    })}
                  </ul>
                </Accordion>
              )
            };
  
            // 直接リンク表示
            const renderDirectLink = (category)=> {
              const item = category.vehicleLibraryItems[0];
              let iconClass = '';
              if (item.linkIcon1 === 'PDF') {
                iconClass = ' pdf';
              } else if (item.linkIcon1 === 'E-Book') {
                iconClass = ' e-book';
              } else if (item.linkIcon1 === 'Link') {
                if (item.linkTarget1 === true) {
                  iconClass = ' blank';
                } else {
                  iconClass = ' link';
                }
              }
              return (
                <a className={'OwnerLibrary__library-data__link-direct' + iconClass}
                   href={item.linkItem1}
                   target={(item.linkTarget1 === true) ? '_blank' : ''}
                >{category.manualCategory}</a>
              )
            };
  
            // 規約同意リンク表示
            const renderModalLink = (category)=> {
              return (
                <a className="OwnerLibrary__library-data__link-modal"
                   href="javascript:void(0);"
                   onClick={(e)=> {
                     e.preventDefault();
                     // モーダル開く
                     this.openModal(category.vehicleLibraryItems[0]);
                   }}
                >{category.manualCategory}</a>
              )
            };
  
            return (
              <ul className="OwnerLibrary__library-data__category">
                {libraryCategory.map((category, index)=> {
                  if (category.useVersionControl === true) {
                    return (
                      <li key={index}>
                        
                        {renderAccordion(category)}
                        
                      </li>
                    )
                  } else {
                    if (category.vehicleLibraryItems[0].linkFunction === 'Direct-Link') {
                      return (
                        <li key={index}>
                          
                          {renderDirectLink(category)}
                          
                        </li>
                      )
                    } else if (category.vehicleLibraryItems[0].linkFunction === 'Modal-Agreement-Window') {
                      return (
                        <li key={index}>
                          
                          {renderModalLink(category)}
                          
                        </li>
                      )
                    } else {
                      return null;
                    }
                  }
                })}
              </ul>
            )
          } else {
            return null;
          }
        };
        
        return (
          <div className="OwnerLibrary__library-data">
            <div className="OwnerLibrary__library-data__container">
              <div className="OwnerLibrary__library-data__box">
                <div className="OwnerLibrary__library-data__box-left">
                  {(this.state.isMounted === true) ?
                    <img className="OwnerLibrary__library-data__image-generation"
                         src={this.getBodyTypeImageSrc(this.state.currentVehicleType, this.state.currentModelName, this.state.currentCarId, this.state.currentCarTypeCode, 'l', true)}/>
                    : null}
                  {(releaseDate && releaseDate !== '') ?
                    <p className="OwnerLibrary__library-data__release-date">発売年月 : {this.formatReleaseDate(generationInfo.releaseDate)}〜</p>
                    : null}
                  {(vinData && vinData !== '') ?
                    <div className="OwnerLibrary__library-data__vin-data Wysiwyg">
                      <span dangerouslySetInnerHTML={{__html: vinData}}/>
                    </div>
                    : null}
                </div>
                <div className="OwnerLibrary__library-data__box-right">
                  {(this.props.libraryTitle && this.props.libraryTitle !== '') ?
                    <h5 className="OwnerLibrary__library-data__heading">{this.props.libraryTitle}</h5>
                    : null}
                    
                  {renderLibraryCategory()}
                  
                  {(information && information !== '') ?
                    <div className="OwnerLibrary__library-data__information Wysiwyg">
                      <span dangerouslySetInnerHTML={{__html: information}}/>
                    </div>
                    : null}
                </div>
              </div>
            </div>
            {(freeArea && 1 <= freeArea.length) ? getComponents(freeArea): null}
          </div>
        )
      } else {
        return null;
      }
    };
    
    // モーダル内アイテム表示
    const renderModalItem = ()=> {
      if (this.state.vehicleLibraryItem) {
        return (
          <ModalItem {...{
            linkItem1: this.state.vehicleLibraryItem.linkItem1 || null,
            linkTarget1: this.state.vehicleLibraryItem.linkTarget1 || null,
            linkButtonTitle1: this.state.vehicleLibraryItem.linkButtonTitle1 || null,
            linkIcon1: this.state.vehicleLibraryItem.linkIcon1 || null,
            linkUpdatedate1: this.state.vehicleLibraryItem.linkUpdatedate1 || null,
            linkItem2: this.state.vehicleLibraryItem.linkItem2 || null,
            linkTarget2: this.state.vehicleLibraryItem.linkTarget2 || null,
            linkButtonTitle2: this.state.vehicleLibraryItem.linkButtonTitle2 || null,
            linkIcon2: this.state.vehicleLibraryItem.linkIcon2 || null,
            linkUpdatedate2: this.state.vehicleLibraryItem.linkUpdatedate2 || null,
            titleAndPreText: this.state.vehicleLibraryItem.titleAndPreText || null,
            agreementText: this.state.vehicleLibraryItem.agreementText || null,
            linkAreaTitle: this.state.vehicleLibraryItem.linkAreaTitle || null,
            lowerDescription: this.state.vehicleLibraryItem.lowerDescription || null,
          }}/>
        )
      } else {
        return null;
      }
    };
    
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <section className="OwnerLibrary">
          {/*<h3 className="OwnerLibrary__heading">オーナーズマニュアル</h3>*/}
          
          {renderNavigation()}

          <div className="OwnerLibrary__fade-in-container open" ref="changeStep">
            
            {renderVehicleTypeSelect()}
            
            <div className="OwnerLibrary__fade-in-container open" ref="changeBodyType">
              
              {renderBodyTypeSelect()}
              
              {renderGenerationSelect()}
              
              <div className="OwnerLibrary__fade-in-container open" ref="changeGeneration">

                {renderLibraryData()}
              
              </div>
            </div>
          </div>
          <ModalWindow ref="modalWindow" type="Light" onClose={this.onCloseModal}>
            
            {renderModalItem()}
          
          </ModalWindow>
        </section>
      </Wrapper>
    )
  }
  
  // ボディタイプ画像パス取得
  getBodyTypeImageSrc = (vehicleType, modelName, carId, carTypeCode, size = 's', slanting = false, past = false) => {
    //return '/assets-dev/assets/cars/atenza/atenza-sedan/gj12/common/default_' + size + '.png';
    //
    let str = '';
    if (0 <= String(location.hostname).indexOf('localhost')) {
      str = '/assets-dev/assets/cars/';
    } else {
      str = '/globalassets/assets/cars/';
    }
    str = str + modelName + '/';
    str = str + carId + '/';
    str = str + carTypeCode + '/';
    str = str + 'common/';
    //
    if (slanting) {
      if (past) {
        str = str + carId + '_past_chart_' + size + '.png';
      } else {
        str = str + carId + '_chart_' + size + '.png';
      }
    } else {
      if (vehicleType === 'Commercial Car') {
        str = str + 'commercial_default_' + size + '.png';
      } else {
        str = str + 'default_' + size + '.png';
      }
    }
    str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
    return str;
   };
  
  // YYYYMMをYYYY年M月〜にフォーマト
  formatReleaseDate = (YYYYMM = null)=> {
    if (!YYYYMM || YYYYMM === '') return '';
    let str = String(YYYYMM).substr(0, 4) + '年';
    str = str + Number(String(YYYYMM).substr(4, 2)) + '月';
    return str;
  };
  
  // 車種変更
  changeVehicleType = (vehicleType)=> {
    this.setState({
      currentVehicleType: vehicleType
    });
    // フェードインアニメーション
    this.refs.changeBodyType.classList.remove('open');
    setTimeout(() => {
      this.refs.changeBodyType.classList.add('open');
    }, 100);
  };
  
  // ボディタイプ変更
  changeBodyType = (modelName = null, carId)=> {
    let currentCarTypeCode = null;
    if (modelName) {
      let i, max;
      for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
        const model = this.props.models[i];
        if (model.modelName === modelName) {
          let j, max2;
          for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
            const bodyType = model.bodyTypes[j];
            if (isEqualId(bodyType.carId, carId)) {
                currentCarTypeCode = (bodyType.defaultGeneration && bodyType.defaultGeneration !== '') ? bodyType.defaultGeneration : bodyType.defaultCarTypeCode || null;
            }
          }
        }
      }
    } else {
      let i, max;
      for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
        const model = this.props.models[i];
        const modelNameTemp = model.modelName;
        let j, max2;
        for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
          const bodyType = model.bodyTypes[j];
          // if (bodyType.carId === carId) {
          if (isEqualId(bodyType.carId, carId)) {
            modelName = modelNameTemp;
            currentCarTypeCode = (bodyType.defaultGeneration && bodyType.defaultGeneration !== '') ? bodyType.defaultGeneration : bodyType.defaultCarTypeCode || null;
          }
        }
      }
    }
    //
    this.setState({
      currentStep: 1,
      currentModelName: modelName,
      currentCarId: carId,
      currentCarTypeCode: currentCarTypeCode,
    });
    // フェードインアニメーション
    this.refs.changeStep.classList.remove('open');
    setTimeout(() => {
      this.refs.changeStep.classList.add('open');
    }, 100);
  };
  
  // 車種選択に戻る
  backToSelectBodyType = ()=> {
    //
    this.setState({
      currentStep: 0,
      currentVehicleType: 'Passenger Car',
      currentModelName: null,
      currentCarId: null,
      currentCarTypeCode: null,
    });
    // フェードインアニメーション
    this.refs.changeStep.classList.remove('open');
    setTimeout(() => {
      this.refs.changeStep.classList.add('open');
    }, 100);
  };
  
  // 世代選択
  changeGeneration = (carTypeCode)=> {
    this.setState({
      currentCarTypeCode: carTypeCode
    });
    // フェードインアニメーション
    this.refs.changeGeneration.classList.remove('open');
    setTimeout(() => {
      this.refs.changeGeneration.classList.add('open');
    }, 100);
    // アコーディオン閉じる
    let i, max;
    for (i = 0, max = this.refsAccordionArr.length; i < max; i = i + 1) {
      const ref = this.refsAccordionArr[i];
      if (ref && this.refs[ref]) this.refs[ref].close();
    }
    // if (this.refs.accordion) this.refs.accordion.close();
    // setTimeout(() => {
    //   if (this.refs.accordion) {
    //     this.refs.accordion.close();
    //   }
    // }, 1000);
    //
  };
  
  // モーダルウィンドウ開く
  openModal = (vehicleLibraryItem) => {
    this.setState({
      vehicleLibraryItem: vehicleLibraryItem
    });
    //
    this.refs.modalWindow.open('Light', 'Light');
    // BODYのスクロール無効化
    //BodyControl.openModal();
  };
  
  // モーダルウィンドウ閉じる
  onCloseModal = () => {
    // BODYのスクロール無効化を解除
    //BodyControl.closeModal();
  };
  
  // URLパラメータでダイレクト遷移
  setCurrentByParams = () => {
    
    const setCurrent = (bodyTypeId, carTypeCode) => {
  
      // BodyType情報取得
      const getBodyTypeInfo = ()=> {
        let i, max;
        for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
          let j, max2;
          for (j = 0, max2 = this.props.models[i].bodyTypes.length; j < max2; j = j + 1) {
            // if (this.props.models[i].bodyTypes[j].carId === bodyTypeId) {
            if (isEqualId(this.props.models[i].bodyTypes[j].carId, bodyTypeId)) {
              return this.props.models[i].bodyTypes[j];
            }
          }
        }
        return null;
      };
      const bodyTypeInfo = getBodyTypeInfo();
      if (bodyTypeInfo && carTypeCode) {
    
        // 世代情報取得
        const getGenerationInfo = ()=> {
          let i, max;
          for (i = 0, max = bodyTypeInfo.generation.length; i < max; i = i + 1) {
            // if (bodyTypeInfo.generation[i].carTypeCode === carTypeCode) {
            if (isEqualId(bodyTypeInfo.generation[i].carTypeCode, carTypeCode)) {
              return bodyTypeInfo.generation[i];
            }
          }
          return null;
        };
        const generationInfo = getGenerationInfo();
        if (generationInfo) {
          // BodyType及び世代が存在した場合
          // ボディタイプ変更
          this.changeBodyType(null, bodyTypeId);
          // 世代選択
          this.changeGeneration(carTypeCode);
        } else {
          // BodyTypeのみ存在した場合
          // ボディタイプ変更
          this.changeBodyType(null, bodyTypeId);
        }
      } else {
        // BodyTypeのみ存在した場合
        // ボディタイプ変更
        this.changeBodyType(null, bodyTypeId);
      }

    };
    
    // URLパラメータでカレント変更
    let carId = BodyControl.getUrlParameter('car_id');
    let carTypeCode = BodyControl.getUrlParameter('car_type_code');
    if (carId || carTypeCode) {
      if (carId && carTypeCode) {
        setCurrent(carId, carTypeCode);
      } else if (carId) {
        setCurrent(carId);
      }
    } else {
      
      // ブロックのCookieに保温されている値でカレント変更
      carId = getCookie('mj_ombt');
      carTypeCode = getCookie('mj_omgen');
      if (carId || carTypeCode) {
        if (carId && carTypeCode) {
          setCurrent(carId, carTypeCode);
        } else if (carId) {
          setCurrent(carId);
        }
      }
      
    }
    // setCookie('mj_ombt', 'CarId002');
    // setCookie('mj_omgen', 'Grade008');
    
  }
  
}

export default OwnerLibrary;

class ModalItem extends Component {
  static propTypes = {
    linkItem1: PropTypes.string,
    linkTarget1: PropTypes.bool,
    linkButtonTitle1: PropTypes.string,
    linkIcon1: PropTypes.string,
    linkUpdatedate1: PropTypes.string,
    linkItem2: PropTypes.string,
    linkTarget2: PropTypes.bool,
    linkButtonTitle2: PropTypes.string,
    linkIcon2: PropTypes.string,
    linkUpdatedate2: PropTypes.string,
    titleAndPreText: PropTypes.string,
    agreementText: PropTypes.array,
    linkAreaTitle: PropTypes.string,
    lowerDescription: PropTypes.string,
  };
  static defaultProps = {
    linkItem1: null,
    linkTarget1: false,
    linkButtonTitle1: null,
    linkIcon1: null,
    linkUpdatedate1: null,
    linkItem2: null,
    linkTarget2: false,
    linkButtonTitle2: null,
    linkIcon2: null,
    linkUpdatedate2: null,
    titleAndPreText: null,
    agreementText: null,
    linkAreaTitle: null,
    lowerDescription: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  render() {
    
    const renderLink = (linkItem, linkTarget, linkButtonTitle, linkIcon, linkUpdatedate)=> {
      if (linkItem && linkItem !== '' && linkButtonTitle && linkButtonTitle !== '') {
        let iconSrc = null;
        let hoverIconSrc = null;
        let linkType = 'Button';
        if (linkIcon === 'PDF') {
          iconSrc = OwnerLibrary.iconPdfBlack;
          hoverIconSrc = OwnerLibrary.iconPdfWhite;
          linkType = 'Button-With-Icon';
        } else if (linkIcon === 'E-Book') {
          iconSrc = OwnerLibrary.iconCatalogBlack;
          hoverIconSrc = OwnerLibrary.iconCatalogWhite;
          linkType = 'Button-With-Icon';
        } else if (linkIcon === 'Link') {
          if (linkTarget === true) {
            iconSrc = OwnerLibrary.iconBlankBlack;
            hoverIconSrc = OwnerLibrary.iconBlankWhite;
            linkType = 'Button-With-Icon';
          } else {
            iconSrc = null;
            hoverIconSrc = null;
            linkType = 'Button';
          }
        }
        return (
          <li>
            <Cta
              {...{
                ctaType: 'Free',
                href: linkItem,
                text: linkButtonTitle,
                targetBlank: (linkTarget === true) ? true : false,
                linkType: linkType,
                color: 'Dark',
                buttonStyle: 'Standard',
                iconSrc: iconSrc,
                hoverIconSrc: hoverIconSrc,
              }}
            />
            {(linkUpdatedate && linkUpdatedate !== '') ? <p className="OwnerLibrary__modal-item__update">更新日：{this.formatReleaseDate(linkUpdatedate)}</p> : null}
          </li>
        )
      } else {
        return null;
      }
    };
    
    return (
      <section className="OwnerLibrary__modal-item">
        <div className="OwnerLibrary__modal-item__container">
          {(this.props.titleAndPreText && this.props.titleAndPreText !== '') ?
            <div className="OwnerLibrary__modal-item__header Wysiwyg" dangerouslySetInnerHTML={{__html: this.props.titleAndPreText}}/>
            : null}
          {(this.props.agreementText && this.props.agreementText instanceof Array && 1 <= this.props.agreementText.length) ?
            <div className="OwnerLibrary__modal-item__agreement">{getComponents(this.props.agreementText)}</div>
            : null}
          <dl className="OwnerLibrary__modal-item__list-dl">
            {(this.props.linkAreaTitle && this.props.linkAreaTitle !== '') ?
              <dt>{this.props.linkAreaTitle}</dt>
              : null}
            <dd>
              <ul className="OwnerLibrary__modal-item__list-ul">
                {renderLink(this.props.linkItem1, this.props.linkTarget1, this.props.linkButtonTitle1, this.props.linkIcon1, this.props.linkUpdatedate1)}
                {renderLink(this.props.linkItem2, this.props.linkTarget2, this.props.linkButtonTitle2, this.props.linkIcon2, this.props.linkUpdatedate2)}
              </ul>
            </dd>
          </dl>
          {(this.props.lowerDescription && this.props.lowerDescription !== '') ?
            <div className="OwnerLibrary__modal-item__description Wysiwyg" dangerouslySetInnerHTML={{__html: this.props.lowerDescription}}/>
            : null}
        </div>
      </section>
    );
  }
  
  // YYYYMMをYYYY年M月D日にフォーマト
  formatReleaseDate = (YYYYMMDD = null)=> {
    if (!YYYYMMDD || YYYYMMDD === '') return '';
    let str = String(YYYYMMDD).substr(0, 4) + '年';
    str = str + Number(String(YYYYMMDD).substr(4, 2)) + '月';
    str = str + Number(String(YYYYMMDD).substr(6, 2)) + '日';
    return str;
  };
  
}




// WEBPACK FOOTER //
// ./src/containers/owner-library/index.jsx